<div class="row">
  <div class="col-12">
    <p class="org-title" *ngIf="user && user.role && auth.isAdmin() && this.isShow">Organization Name</p>
    <mat-form-field class="w-100" *ngIf="auth.isAdmin() && this.isShow" appearance="outline">
      <mat-select placeholder="Organization" [(ngModel)]="Organization" (selectionChange)="loadGrid($event)">
        <mat-option value="Select-ALL"> Select-ALL</mat-option>
        <mat-option *ngFor="let org of orgList" value="{{ org.id }}"> {{ org.organizationname }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>

<div class="row">
  <div class="col-lg-12 px-0">
    <h4 class="landing-title">{{activepagename}}</h4>
    <div class="main-card card">
      <div class="card-body">
        <dx-data-grid
          id="gridContainer"
          [dataSource]="customStore"
          [allowColumnReordering]="true"
          [allowColumnResizing]="true"
          [columnAutoWidth]="true"
          [columnMinWidth]="100"
          [width]="'100%'"
          [columnResizingMode]="'widget'"
          [showBorders]="true"
          [rowAlternationEnabled]="true"
          [showColumnLines]="true"
          [showRowLines]="false"
          [filterValue]="filterValue"
          [filterSyncEnabled]="true"
          (onContentReady)="contentReady($event)"
          (onSelectionChanged)="onSelectionChanged($event)"
          (onRowPrepared)="onRowPrepared($event)"
          (onCellPrepared)="onCellPrepared($event)"
          (onExporting)="onExporting($event)"
          [remoteOperations]="{ filtering: true, sorting: true, paging: true }"
          #dataGrid>
          <dxo-load-panel [enabled]="false"></dxo-load-panel>
          <dxo-export [enabled]="true" [formats]="['pdf', 'xlsx']"></dxo-export>
          <dxo-filter-panel [visible]="false"></dxo-filter-panel>
          <dxo-column-chooser *ngIf="updateGrid?.chooser" [enabled]="true" mode="select">
            <dxo-position my="right top" at="right top" of=".dx-datagrid-column-chooser-button">
            </dxo-position>
          </dxo-column-chooser>
          <dxo-paging [pageSize]="5"></dxo-paging>
          <dxo-pager
            [visible]="true"
            [allowedPageSizes]="[5, 10, 15, 20]"
            [displayMode]="displayMode"
            [showPageSizeSelector]="true"
            [showInfo]="true"
            [showNavigationButtons]="true"></dxo-pager>
          <!--end pagination-->
          <dxo-filter-builder [customOperations]="customOperations"> </dxo-filter-builder>
          <dxo-filter-builder-popup [position]="popupPosition"> </dxo-filter-builder-popup>
          <dxo-filter-row [visible]="true"></dxo-filter-row>
          <dxo-state-storing [enabled]="true" type="custom" [customSave]="customSave"></dxo-state-storing>
          <dxo-header-filter [visible]="true"></dxo-header-filter>
          <dxo-selection mode="single" *ngIf="updateGrid?.rowSelection"></dxo-selection>
          <ng-container *ngFor="let column of columns; let i = index">
            <ng-container *ngIf="column.hide !== true">
              <ng-container *ngIf="column.link; else noLink">
                <dxi-column [allowHiding]="column.allowHiding" [fixed]="column.fixed" [visible]="column.visible" [dataField]="column.columnDef" [caption]="column.header" [allowFiltering]="column.filter"
                  cellTemplate="cellTemplate"></dxi-column>
              </ng-container>
              <ng-template #noLink>
                <ng-container *ngIf="column.icon; else noIcon">
                  <dxi-column [allowHiding]="column.allowHiding" [fixed]="column.fixed"  [visible]="column.visible" [dataField]="column.columnDef" [caption]="column.header" [allowFiltering]="column.filter"
                    cellTemplate="iconTemplate"></dxi-column>
                </ng-container>
              </ng-template>
              <ng-template #noIcon>
                <ng-container *ngIf="column.dateFormat; else noDate">
                  <dxi-column [allowHiding]="column.allowHiding" [fixed]="column.fixed" *ngIf="column.dateFormat === 'date' || column.dateFormat === 'datetime'"
                  [visible]="column.visible" [dataField]="column.columnDef" [caption]="column.header" [allowFiltering]="column.filter"
                    [dataType]="column.dateFormat" [format]="getDateFormat(column.dateFormat)"  >
                  </dxi-column>
                </ng-container>
              </ng-template>
              <ng-template #noDate>
                <dxi-column [allowHiding]="column.allowHiding" [fixed]="column.fixed" [visible]="column.visible" [dataField]="column.columnDef" [caption]="column.header" [allowFiltering]="column.filter">
                </dxi-column>
              </ng-template>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="
              updateGrid &&
              (updateGrid?.externalLink ||
                updateGrid?.openPopup ||
                updateGrid?.edit ||
                updateGrid?.delete ||
                updateGrid?.delete ||
                updateGrid?.download ||
                updateGrid?.activatePage ||
                updateGrid?.deactivatePage)">
            <dxi-column [allowHiding]="column.allowHiding" [fixed]="column.fixed" [visible]="column.visible"  [width]="120" [allowFiltering]="false" [allowSorting]="false" caption="Action"
              cellTemplate="editCellTemplate"></dxi-column>
            <div class="action-icons" *dxTemplate="let d of 'editCellTemplate'">
              <a href="javascript:void(0)" *ngIf="updateGrid?.externalLink" class="no-bg" matTooltip="Open"
                (click)="openLink(d)">
                <em class="fa fa-external-link" aria-hidden="true"></em>
              </a>
              <a href="javascript:void(0)" *ngIf="updateGrid?.openPopup" class="no-bg" matTooltip="Open"
                (click)="openPopupLink(d)">
                <em class="fa fa-newspaper-o" aria-hidden="true"></em>
              </a>
              <a href="javascript:void(0)" *ngIf="updateGrid?.download" class="no-bg" matTooltip="Download"
                (click)="downloadData(d)">
                <em class="fa fa-download" aria-hidden="true"></em>
              </a>
              <a href="javascript:void(0)" *ngIf="updateGrid?.edit && showVersions && !d.data.published"
                class="no-bg mr-2" matTooltip="Edit" (click)="editData(d)">
                <em class="fa fa-pencil" aria-hidden="true"><span class="sr-only">Edit</span></em>
                <span class="sr-only">View</span>
              </a>
              <a href="javascript:void(0)" *ngIf="updateGrid?.editRecord" class="no-bg mr-2" matTooltip="Edit"
                (click)="editData(d)">
                <em class="fa fa-pencil" aria-hidden="true"><span class="sr-only">Edit</span></em>
                <span class="sr-only">View</span>
              </a>
              <a href="javascript:void(0)" *ngIf="updateGrid?.duplicate && !showVersions" class="no-bg mr-2"
                matTooltip="Copy" (click)="duplicateDate(d)">
                <em class="fa fa-copy" aria-hidden="true" fieldKey="PAG_DES_GRID_LIST_COPY">
                  <span class="sr-only">Copy</span></em>
              </a>
              <a href="javascript:void(0)" *ngIf="updateGrid?.duplicate && showVersions" class="no-bg mr-2"
                matTooltip="Copy Version" (click)="duplicateVersion(d)">
                <em class="fa fa-copy" *showField="'PAG_DES_GRID_LIST_VERSION'" aria-hidden="true"><span
                    class="sr-only">Copy Version</span></em>
              </a>
              <a href="javascript:void(0)" *ngIf="!d.data.ribbonconfig && updateGrid?.view && showVersions" class="no-bg mr-2" matTooltip="View"
                fieldKey="PAG_DES_GRID_LIST_VERSION" (click)="viewData(d)">
                <em class="fa fa-eye" aria-hidden="true"><span class="sr-only">View</span></em>
              </a>
              <a href="javascript:void(0)" *ngIf="updateGrid?.viewRecord" class="no-bg mr-2" matTooltip="View"
                (click)="viewData(d)">
                <em class="fa fa-eye" aria-hidden="true"><span class="sr-only">View</span></em>
              </a>
              <a href="javascript:void(0)" *ngIf="updateGrid?.emailview && showVersions" class="no-bg mr-2"
                matTooltip="Preview" (click)="viewData(d)">
                <em class="fa fa-eye" aria-hidden="true"><span class="sr-only">View</span></em>
              </a>
              <a href="javascript:void(0)" title="view"
                *ngIf="updateGrid?.version && !showVersions && islocked(updateGrid, d.data) && isEnable(updateGrid, d.data)" class="no-bg"
                matTooltip="Versions" (click)="viewVersion(d)">
                <em class="fa fa-code-fork" title="View" aria-hidden="true"></em>
              </a>
              <a href="javascript:void(0)" *ngIf="!d.data.isEnable && updateGrid?.activatePage" class="no-bg ml-2"
                matTooltip="Activate" (click)="activatePages(d)">
                <span class="material-symbols-outlined activate">check</span>
              </a>

              <a href="javascript:void(0)" *ngIf="d.data.isEnable && updateGrid?.deactivatePage" class="no-bg ml-2"
                matTooltip="Deactivate" (click)="deactivatePages(d)">
                <span class="material-symbols-outlined deactivate">close</span>
              </a>
              <a href="javascript:void(0)" *ngIf="showVersions && !d.data.isactive && d.data.published"
                class="no-bg mr-2" matTooltip="Activate" (click)="activatePageVersion(d)">
                <em class="fa fa-check-circle-o" *showField="'PAG_DES_GRID_LIST_ACTIVATE'" aria-hidden="true"><span
                    class="sr-only">Activate</span></em>
                <span class="sr-only">View</span>
              </a>
              <span *ngIf="showVersions && !d.data.isactive && !d.data.published" class="no-bg mr-2"
                matTooltip="This version is not published">
                <em class="fa fa-exclamation-triangle text-warning" aria-hidden="true">
                  <span class="sr-only">This version is not published</span>
                </em>
                <span class="sr-only">View</span>
              </span>
              <a href="javascript:void(0)" *ngIf="updateGrid?.lock && d.data.locked" (click)="check(updateGrid, d)"
                class="no-bg ml-2" matTooltip="Locked By - {{ d?.data?.lockedbyUser?.firstname }}">
                <em *ngIf="updateGrid?.lock && d.data.locked" class="fa fa-lock" aria-hidden="true"></em>
              </a>
              <a href="javascript:void(0)" *ngIf="updateGrid?.delete" class="no-bg" matTooltip="Delete"
                (click)="deleteData(d)">
                <em class="fa fa-trash" aria-hidden="true"></em>
              </a>
              <a href="javascript:void(0)" *ngIf="updateGrid?.toggle" class="no-bg"
                [matTooltip]="d.data.isactive === true ? 'Deactivate' : 'Activate'" (click)="activeUser(d)">
                <em *ngIf="updateGrid?.toggle && d.data.isactive === true" class="fa fa-toggle-on"></em>
                <em *ngIf="updateGrid?.toggle && d.data.isactive === false" class="fa fa-toggle-off"></em>
              </a>
              <a href="javascript:void(0)" *ngIf="updateGrid?.activeordeactive" class="no-bg" (click)="deleteData(d)">
                <em *ngIf="updateGrid?.activeordeactive && d.data.activeflag === 1" class="fa fa-toggle-on"></em>
                <em *ngIf="updateGrid?.activeordeactive && d.data.activeflag === 0" class="fa fa-toggle-off"></em>
              </a>
            </div>
          </ng-container>

          <div *dxTemplate="let d of 'cellTemplate'">
            <span href="javascript:void(0)" *ngIf="d.value && d.value !== 'null'" class="link-data" (click)="getRouter(d)">{{
              d.value !== 'null' ? d.value : ''
              }}</span>
          </div>
          <ng-container *ngIf="updateGrid.linkVisible">
            <div *dxTemplate="let d of 'cellTemplate'"(click)="navigateLink($event, d)">
              <span *ngIf="d.value && d.value !== 'null'" #contentWrapper [innerHTML]="d.value | safeHtml">{{
                d.value !== 'null' ? d.value : ''
              }}</span>
            </div>
          </ng-container>
          <div *dxTemplate="let d of 'iconTemplate'">
            <em class="fa fa-book" (click)="popup(d.value)"></em>
          </div>
        </dx-data-grid>

        <ng-template #callNarrativePopup>
          <h2 matDialogTitle>Narrative</h2>
          <div [innerHTML]="narrativeData"></div>
          <div class="text-right">
            <button mat-button (click)="closeNarrativePopup()" role="button" class="btn btn-cancel mr-2">Close</button>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>
